import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import moment from 'moment';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  inputFields: {
    minWidth: '176px',
    height: '53px',
  },
}));

interface ApprovedOnProps {
  readOnly?: boolean;
}

export const ApprovedOn = ({ readOnly }: ApprovedOnProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { control, formState: { errors } } = useFormContext();

  return (
    <Controller
      control={control}
      name={'approvalDate'}
      render={({ field: { onChange, value, ...rest } }) => {
        const approvalDate = moment(value ?? null);
        return (
          <React.Fragment>
            <DateRangePicker
              onChange={newValue => {
                const isReadOnlyField = readOnly !== undefined ? readOnly : true;
                if (!isReadOnlyField && newValue.startDate !== undefined) {
                  const newDate = moment(newValue.startDate);
                  const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;
                  onChange(setTo);
                } else if (!isReadOnlyField) {
                  onChange(null);
                }
              }}
              value={value}
              onCancel={() => {}}
              clear
              open={false}
              variant="filled"
              single
              placeholder={t('placement.placementMods.approvalDate')}
              useMaxWidth={true}
              showIcon={true}
              className={classes.inputFields}
              labelClass={classes.inputFields}
              actionBar={false}
              clickAway={true}
              trailingIconShow={true}
              readOnly={readOnly !== undefined ? readOnly : true}
              required={false}
              keepClickAwayVal={true}
              initialDateRange={{
                startDate: approvalDate.isValid() ? new Date(approvalDate.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                endDate: approvalDate.isValid() ? new Date(approvalDate.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                useLabelAsValue: true,
              }}
              error={!isNullOrUndefined(errors?.approvalDate)}
              helperText={!isNullOrUndefined(errors?.approvalDate) ? (errors?.approvalDate?.message as string) || '' : undefined}
              {...rest}
            />
          </React.Fragment>
        );
      }}
    />
  );
};
